import { createConfirmation } from 'react-confirm';
import ConfirmModal from 'components/includes/ConfirmModal';
import AlertModal from 'components/includes/AlertModal';
import PromptModal from 'components/includes/PromptModal';

import avatar1 from 'images/avatars/1.png';
import avatar2 from 'images/avatars/2.png';
import avatar3 from 'images/avatars/3.png';
import avatar4 from 'images/avatars/4.png';
import avatar5 from 'images/avatars/5.png';
import avatar6 from 'images/avatars/6.png';
import avatar7 from 'images/avatars/7.png';
import avatar8 from 'images/avatars/8.png';
import avatar9 from 'images/avatars/9.png';
import avatar10 from 'images/avatars/10.png';
import logo from 'images/logo/logo.png';

const utils = {
  hasPermission(user, permission, scope) {
    return user && user.permissions && (
      (user.permissions.global && user.permissions.global.indexOf(permission) > -1) ||
      (user.permissions[scope] && user.permissions[scope].indexOf(permission) > -1)
    );
  },
  ensureHttp(s) {
    if (s && s.toLowerCase().indexOf('http') === -1) return `http://${s}`;
    return s;
  },
  activePath(pattern) {
    const match = window.location.pathname.match(new RegExp(pattern, 'i'));
    return match && match.length > 0;
  },
  absoluteUrl(path) {
    return window.location.protocol + '//' + window.location.host + path;
  },
  avatarUrl(user) {
    const avatar = (user && user.avatar) || '9';
    if (avatar.length < 3) {
      const a = utils.defaultAvatars().filter(a => a.key === avatar)[0];
      return a && a.url;
    }
    return user.avatarUrl;
  },
  defaultAvatars() {
    return [
      { key: '1', url: avatar1 },
      { key: '2', url: avatar2 },
      { key: '3', url: avatar3 },
      { key: '4', url: avatar4 },
      { key: '5', url: avatar5 },
      { key: '6', url: avatar6 },
      { key: '7', url: avatar7 },
      { key: '8', url: avatar8 },
      { key: '9', url: avatar9 },
      { key: '10', url: avatar10 },
    ];
  },
  hasEmailSubscription(user, sub) {
    return user && user.subscriptions && user.subscriptions.email && user.subscriptions.email.indexOf(sub) > -1;
  },
  teamLogo(team) {
    return (team && team.logoUrl) || logo;
  },
  confirm(title, content) {
    const confirm = createConfirmation(ConfirmModal);
    return confirm({ title, confirmation: content });
  },
  alert(title, content) {
    const alert = createConfirmation(AlertModal);
    return alert({ title, confirmation: content });
  },
  prompt(title, question, onComplete) {
    const prompt = createConfirmation(PromptModal);
    return prompt({ title, prompt: question, onComplete });
  },
};

export default utils;
